import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { REQUISITION_STATUS } from '../constants/requisition'

export type PurchaseOrderStatus =
  | typeof REQUISITION_STATUS.APPROVED
  | typeof REQUISITION_STATUS.PARTIALLY_APPROVED

export type ProcurementReferences = {
  purchaseOrder: string | null
  purchaseOrderItem: string | null
  movementType: string | null
  itemDocument: string | null
  itemDocumentItem: string | null
  transactionDate: string | null
  invoiceNumber: string | null
  invoiceAmount: number | null
  purchaseOrderID: string | null
  goodsReceiptReference: string | null
}
export type PurchaseOrderItem = ProcurementReferences & {
  productId: string
  productName: string
  brand: string | null
  sellerCompanyId: string
  supplierName: string
  quantity: number
  approvedQuantity: number
  unitOfMeasure: string
  priceAmount: number | null
  currency: string | null
  lineAmount: number | null
  ItemId: string | null
  BusinessUnitId: string | null
  storageLocation: string | null
  batchId: string | null
  supplierId: string | null
  companyCode: string | null
}
export type PurchaseOrder = {
  id: string
  number: string
  status: PurchaseOrderStatus
  companyId: string
  buyer: { id: string; name: string; email: string; phone: string }
  requisitionId: string
  requisitionReference: string
  requesterId: string
  requesterName?: string
  reviewerName?: string
  recipient: string
  deliveryAddress: string
  collectionLocation: string
  note: string
  neededBy: string | null
  businessUnitId: string | null
  storageLocation: string | null
  companyCode: string | null
  reviewedBy: string
  reviewerEmail: string
  reviewedAt: string | null
  submittedAt: string | null
  createdAt: string
  items: PurchaseOrderItem[]
  knownSubtotals: { currency: string; amount: number }[]
  unpricedItemCount: number
}

@Injectable({ providedIn: 'root' })
export class PurchaseOrderService {
  private http = inject(HttpClient)
  private url = environment.baseUrl + 'purchase-orders'
  list(): Observable<PurchaseOrder[]> {
    return this.http.get<PurchaseOrder[]>(this.url)
  }
  get(id: string): Observable<PurchaseOrder> {
    return this.http.get<PurchaseOrder>(`${this.url}/${encodeURIComponent(id)}`)
  }
  download(id: string): Observable<Blob> {
    return this.http.get(`${this.url}/${encodeURIComponent(id)}/pdf`, {
      responseType: 'blob',
    })
  }
  retry(requisitionId: string): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(
      `${environment.baseUrl}requisitions/${encodeURIComponent(requisitionId)}/purchase-order`,
      {},
    )
  }
}
